import MainHeader from 'components/v2/modules/header/main-header';

const MainLayout = ({
  children,
  showHeader = true,
}: {
  children: React.ReactNode;
  showHeader?: boolean;
}) => {
  return (
    <>
      {showHeader && <MainHeader />}
      <div className="mx-auto max-w-screen-xl">{children}</div>
    </>
  );
};

export default MainLayout;
